import { CacheType, getCache, removeCache, setCache } from '../common/cache'
import { userLoginSessionKey } from './user'

/** 获取token缓存id */
function getTokenId() {
  return userLoginSessionKey + 'token'
}

/** 接口凭证 */
export let token

/**
 * 获取接口凭证
 * @param {*} value
 */
export async function getToken() {
  if (!token) {
    token = await getCache(getTokenId(), CacheType.system)
  }
  return token
}

/**
 * 设置接口凭证
 * @param {*} value
 */
export function setToken(value) {
  token = value
  if (!value) {
    removeCache(getTokenId(), CacheType.system)
  } else {
    setCache({
      id: getTokenId(),
      type: CacheType.system,
      value: token
    })
  }
}

/**
 * 用户权限列表(页面功能权限)
 */
export let userPermissions

export function clearContextUserPermissions() {
  userPermissions = undefined
}
